import React, { FC, useRef } from "react";
import type { HomeHeroProps } from "@/types";
import { ContentManager } from "../content-manager";
import { Link } from "../link";
import SplitTextAnimation from "../split-text-animation";
import { useInView } from "@/hooks/reveal-in-view";
import { HeroVideo } from "../hero-video";

export const HomeHero: FC<HomeHeroProps> = ({
  title,
  description,
  getInTouch,
  discover,
}) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "0px 0px 25% 0px" });

  return (
    <section className="homeHero">
      <div className="wrapper">
        <div className="homeHero--inner">
          <div ref={ref} className="homeHero--content">
            <SplitTextAnimation
              htmlElement={
                <h1
                  style={{
                    opacity: isInView ? 1 : 0,
                  }}
                >
                  {title}
                </h1>
              }
              isInView={isInView}
              className="homeHero--title"
            />
            <ContentManager
              content={description}
              className="homeHero--description"
            />
            <div className="homeHero--actions">
              <Link
                href={getInTouch.link?.uri as string}
                theme="white"
                fill="full"
                title={getInTouch.text}
              >
                <span>{getInTouch.text}</span>
              </Link>
              <Link
                href={discover.link?.uri as string}
                theme="white"
                fill="outline"
                title={discover.text}
              >
                <span>{discover.text}</span>
              </Link>
            </div>
          </div>
          <div className="homeHero--visual">
            <HeroVideo
              className="homeHero--video"
              desktopSrc="/video/home-hero-desktop.mp4"
              mobileSrc="/video/home-hero-mobile.mp4"
              desktopPoster={{
                webp: "/video/home-hero-poster-desktop.webp",
                jpg: "/video/home-hero-poster-desktop.jpg",
              }}
              mobilePoster={{
                webp: "/video/home-hero-poster-mobile.webp",
                jpg: "/video/home-hero-poster-mobile.jpg",
              }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};
